import Button from "@app/sharedComponents/Button/Button"
import { ThemedText, ThemedView } from "@app/theme"

const SellOfNote = ({continuePayment}) => {
    return(
        <ThemedView flex={1} flexWrap="wrap" p="lg" backgroundColor="bg-surface-primary">
            <ThemedText variant="h5s" color="text-primary" mb="lg">
                Please Note
            </ThemedText>
            <ThemedText variant="b3r" color="text-secondary">
                Lender might have initiated the portfolio sell-off to recover the overdue amount. 
            </ThemedText>
            <ThemedText my="lg" variant="b3r" color="text-secondary">
                You can contact our support team to check the sell-off status.
            </ThemedText>
            <ThemedText mb="lg" variant="b3r" color="text-secondary">
            Or, you can proceed to pay overdue amount.Any additional payments will be adjusted to your principal balance.
            </ThemedText>
            <Button label="Continue" handlePress={continuePayment} />
        </ThemedView>
    )
}

export default SellOfNote